
import axios from "axios";
import { defineComponent, ref, nextTick } from "vue";
import ModalCom1 from "@/components/ModalCom1.vue";

export default defineComponent({
  props: {
    date: String,
    spa: String,
    conWidth: Number,
    rule2: String,
  },
  components: {
    ModalCom1,
  },
  data() {
    return {
      columns: [
        { prop: "image", label: "照片", show: true, fixed: "left", width: "120px" },
        {
          prop: "name",
          label: "姓名",
          show: false,
          sortable: true,
          fixed: "left",
          width: "90px",
        },
        {
          prop: "work_time",
          label: "可約時段",
          show: false,
          sortable: true,
          width: "150px",
        },
        { prop: "price", label: "台費", show: false, sortable: true, width: "90px" },
        { prop: "height", label: "身高", show: false, sortable: true, width: "90px" },
        { prop: "weight", label: "體重", show: false, sortable: true, width: "90px" },
        { prop: "cup", label: "罩杯", show: false, sortable: true, width: "90px" },
        {
          prop: "info",
          label: "介紹",
          show: false,
          sortable: true,
          html: true,
          width: "200px",
        },
      ],
      tableItem: [
        {
          id: "",
          image: "",
          name: "",
          price: "",
          height: "",
          weight: "",
          cup: "",
          work_time: "",
          info: "",
          music: "",
          bento: "",
          ex: "",
          name_his: "",
          week: "",
          w1: "",
          w2: "",
          w3: "",
          w4: "",
          w5: "",
          w6: "",
          w7: "",
        },
      ],
      tableHeight: 0,
      dataLoading: false,
      commSpa: "",
      commName: "",
      activeFieldNames: [
        "image",
        "name",
        "work_time",
        "week",
        "price",
        "height",
        "weight",
        "cup",
        "info",
        "ex",
      ],
      columnOrder: [
        "image",
        "name",
        "work_time",
        "week",
        "price",
        "height",
        "weight",
        "cup",
        "info",
        "ex",
      ],
    };
  },
  methods: {
    moveColumnUp(originalIndex: number) {
      // 雖然傳進來已經保證 >= 2，但保險起見還是判斷 > 2 (才能往上移)
      if (originalIndex > 2) {
        const list = [...this.columnOrder];
        const item = list.splice(originalIndex, 1)[0];
        list.splice(originalIndex - 1, 0, item);
        this.columnOrder = list;
      }
    },

    moveColumnDown(originalIndex: number) {
      if (originalIndex >= 2 && originalIndex < this.columnOrder.length - 1) {
        const list = [...this.columnOrder];
        const item = list.splice(originalIndex, 1)[0];
        list.splice(originalIndex + 1, 0, item);
        this.columnOrder = list;
      }
    },
    selectSpa(spaName) {
      this.dataLoading = true;
      this.tableItem.splice(0);
      var url = "/php/spa_table.php";
      axios
        .post(url, {
          action: "selectWork",
          table_name: spaName,
        })
        .then((res) => {
          this.tableItem = res.data;

          for (var i = 0; i < this.tableItem.length; i++) {
            var item = this.tableItem[i];
            item.image = "https://imgf.gg9453.com/images/spa_daily/" + item.image;

            var ex = "";
            if (item.music == "true") {
              ex += "、送音樂";
            }

            if (item.bento) {
              ex += "、套餐" + item.bento;
            }
            ex = ex.substring(1);
            item.ex = ex;

            if (item.name_his) {
              item.info = item.info + "<br>" + item.name_his;
            }

            var week = "";
            if (item.w1) {
              week += "一" + item.w1 + "<br>";
            }
            if (item.w2) {
              week += "二" + item.w2 + "<br>";
            }
            if (item.w3) {
              week += "三" + item.w3 + "<br>";
            }
            if (item.w4) {
              week += "四" + item.w4 + "<br>";
            }
            if (item.w5) {
              week += "五" + item.w5 + "<br>";
            }
            if (item.w6) {
              week += "六" + item.w6 + "<br>";
            }
            if (item.w7) {
              week += "日" + item.w7 + "<br>";
            }
            item.week = week;
          }

          this.dataLoading = false;

          this.$nextTick(function () {
            const aa: any = this.$refs.elTable;
            aa.clearSort();
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },
    tableRowStyle({ row, column, rowIndex, columnIndex }) {
      if ("true" == row.day_push) {
        return {};
      }
      return {};
    },
    format1(row) {
      var result = "";
      if (1 == row.cellIndex && "true" == row.row.day_push) {
        result +=
          '<img src="https://imgf.gg9453.com/images/hot.png" height="30" width="60"></span><br>';
        //return row.row.name + '<span class="bi bi-hand-thumbs-up red-thumbs"></span>';
      }

      if (1 == row.cellIndex && "true" == row.row.is_new) {
        result +=
          '<img src="https://imgf.gg9453.com/images/new2.png" height="30" width="60"></span><br>';
        //return row.row.name + '<span class="bi bi-stars yellow-stars"></span>';
      }

      //result += row.row.name;
      return result;
    },
    doButton(spa1, name1) {
      this.commSpa = spa1;
      this.commName = name1;
      console.log("doButton=" + this.commSpa + " " + this.commName);
    },
  },
  created() {
    this.tableHeight = window.innerHeight - 300;

    if (this.tableHeight < 500) {
      this.tableHeight = 500;
    }

    if (window.innerWidth < 600) {
      this.columns = [
        { prop: "image", label: "照片", show: true, fixed: "left", width: "65px" },
        {
          prop: "name",
          label: "姓名",
          show: false,
          sortable: true,
          fixed: "left",
          width: "85px",
        },
        {
          prop: "work_time",
          label: "可約時段",
          show: false,
          sortable: true,
          width: "120px",
        },
        {
          prop: "week",
          label: "當周報班",
          show: false,
          sortable: false,
          html: true,
          width: "150px",
        },
        { prop: "price", label: "台費", show: false, sortable: true, width: "70px" },
        { prop: "height", label: "身高", show: false, sortable: true, width: "70px" },
        { prop: "weight", label: "體重", show: false, sortable: true, width: "70px" },
        { prop: "cup", label: "罩杯", show: false, sortable: true, width: "70px" },
        {
          prop: "info",
          label: "介紹",
          show: false,
          sortable: true,
          html: true,
          width: "300px",
        },
        {
          prop: "ex",
          label: "額外服務",
          show: false,
          sortable: true,
          html: true,
          width: "200px",
        },
      ];
    } else {
      var w = "100px";
      if (this.conWidth) {
        w = this.conWidth - 200 - 450 - 200 - 32 + "px";
      }
      this.columns = [
        { prop: "image", label: "照片", show: true, fixed: "left", width: "200px" },
        {
          prop: "name",
          label: "姓名",
          show: false,
          sortable: true,
          fixed: "left",
          width: "120px",
        },
        {
          prop: "work_time",
          label: "可約時段",
          show: false,
          sortable: true,
          width: "200px",
        },
        {
          prop: "week",
          label: "當周報班",
          show: false,
          sortable: false,
          html: true,
          width: "150px",
        },
        { prop: "price", label: "台費", show: false, sortable: true, width: "90px" },
        { prop: "height", label: "身高", show: false, sortable: true, width: "90px" },
        { prop: "weight", label: "體重", show: false, sortable: true, width: "90px" },
        { prop: "cup", label: "罩杯", show: false, sortable: true, width: "90px" },
        {
          prop: "info",
          label: "介紹",
          show: false,
          sortable: true,
          html: true,
          width: "330px",
        },
        {
          prop: "ex",
          label: "額外服務",
          show: false,
          sortable: true,
          html: true,
          width: "200px",
        },
      ];
    }
  },
  mounted() {
    //this.selectSpa(this.spa);
    console.log(this.spa);
  },
  watch: {
    spa: function (val, oldVal) {
      this.selectSpa(val);
    },
  },
  computed: {
    visibleColumns(): any {
      console.log("目前的順序陣列:", JSON.stringify(this.columnOrder));
      // 1. 先過濾
      const filtered = this.columns.filter((col) =>
        this.activeFieldNames.includes(col.prop)
      );

      // 2. 排序（加上 [... ] 確保是新陣列觸發渲染）
      return [...filtered].sort((a, b) => {
        const indexA = this.columnOrder.indexOf(a.prop);
        const indexB = this.columnOrder.indexOf(b.prop);

        // 防呆：如果 index 是 -1，代表該 prop 不在 order 清單中，排到最後面
        const posA = indexA === -1 ? 999 : indexA;
        const posB = indexB === -1 ? 999 : indexB;

        return posA - posB;
      });
    },
  },
});
